import {SingleEvent} from "./SingleEvent";
import {rnDispatchEvent,LitElement,PropertyValues} from "#Shared/Lit";


export class LitElementBase extends LitElement{

    public Display:string='block';
    public UpdateRequested:SingleEvent;
    public ParentElement:LitElementBase;
    private UpdateOrDisconnectedPromise:Promise<any>=null;
    private UpdateOrDisconnectedResolver:(value:any)=>void;
    constructor() {
        super();
        this.UpdateRequested=new SingleEvent<any>();
    }

    createRenderRoot() {
        return this;
    }

    public GetParentClasses():string
    {
        return '';

    }

    public GetParentStyles():Partial<CSSStyleDeclaration>{
        return {
            display:this.style.display==''? this.GetDisplay():this.style.display
        };
    }

    public GetDisplay(){
        return 'block';
    }

    public GetAllLitElements(children:LitElementBase[]=[],node:Node=this){
        if(node instanceof LitElementBase)
            children.push(node);

        node.childNodes.forEach(x=>
            this.GetAllLitElements(children,x)
        );

        return children;
    }
    public get AllUpdateComplete(){
        return new Promise(async resolve => {
            let pendingToUpdate:LitElementBase[]=[];
            while((pendingToUpdate=this.GetAllLitElements().filter(x=>x.isUpdatePending&&x.isConnected)).length>0)
            {
                await Promise.all(pendingToUpdate.map(x=>x.UpdatedOrDisconnected));
            }

            resolve(true);
        })
    }


    get UpdatedOrDisconnected(){
        if(this.UpdateOrDisconnectedPromise==null)
            this.UpdateOrDisconnectedPromise=new Promise(resolve => {
                this.UpdateOrDisconnectedResolver=resolve;
                this.updateComplete.then(x=>{
                    this.MaybeFireUpdateOrDisconnected();
                });
            });

        return this.UpdateOrDisconnectedPromise;
    }


    connectedCallback() {
        super.connectedCallback();
        let parent=this.parentNode;
        this.ParentElement=null;
        while(parent!=null)
        {
            if(parent instanceof LitElement) {
                this.ParentElement = parent as any;
                this.ParentElement.UpdateRequested.Subscribe(this,()=>this.forceUpdate());
                break;
            }

            parent=parent.parentNode;
        }



    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.MaybeFireUpdateOrDisconnected();
        if(this.ParentElement!=null)
            this.ParentElement.UpdateRequested.Unsubscribe(this);
    }

    private RenderParentStyles(){
        let styles=this.GetParentStyles();
        if(styles!=null)
            for(let rule in styles) {
                if (styles[rule] == null)
                    continue;

                (this.renderRoot as HTMLElement).style[rule] = styles[rule];
            }


        let classes=this.GetParentClasses();
        if(classes!=null&&classes!='')
            for(let currentClass of classes.split(' ')) {
                (this.renderRoot as HTMLElement).classList.add(currentClass);
            }

    }

    removeController(controller: any) {
        super.removeController(controller);
    }

    public forceUpdate()
    {
        this.requestUpdate();
        this.RenderParentStyles();
        this.UpdateRequested.Publish();
    }
    protected firstUpdated(_changedProperties: PropertyValues) {
        super.firstUpdated(_changedProperties);
        this.RenderParentStyles();


    }

    public FireEvent(eventName:string,args:any=null,bubbles:boolean=false)
    {
        return rnDispatchEvent(this,eventName,args,bubbles);
    }

    private MaybeFireUpdateOrDisconnected() {
        if(this.UpdateOrDisconnectedResolver!=null) {

            this.UpdateOrDisconnectedResolver(null);
            this.UpdateOrDisconnectedPromise=null;
            this.UpdateOrDisconnectedResolver=null;
        }

    }
}